import { DateTime } from "luxon";

export const getWeeklySearchRange = (date: Date) => {
  const dt = DateTime.fromJSDate(date);
  const isSunday = dt.weekday === 7;
  const startLocal = isSunday
    ? dt.startOf("day")
    : dt.startOf("week").minus({ days: 1 }).startOf("day");
  const endLocal = startLocal.plus({ days: 6 }).endOf("day");
  return [startLocal.toUTC(), endLocal.toUTC()];
};
